import React, {Component} from 'react';
import styled, {keyframes} from 'styled-components';

import spinner from 'images/general/spinner.svg';

const rotate360 = keyframes`
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
`;

const SpinnerWrap = styled.div`
  width: 75px;
  height: 75px;
  margin: 20px auto;
  img {
    width: 75px;
    animation: ${rotate360} 2s linear infinite;
  }

`;

class Spinner extends Component {
  render() {
    return(
      <SpinnerWrap>
        <img src={spinner} alt="Завантаження" />
      </SpinnerWrap>
    )
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/spinner/index.js